import { ReactNode } from "react";
import { DotLegalMultiSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { RiskScoringForm } from "./useRiskScoringForm";

interface IRiskParticipantsPicker {
    form: RiskScoringForm;
    footer?: ReactNode;
}

// The one participant selection, shared by the reassess form and the reconfirm stage, so both offer the same users.
export function RiskParticipantsPicker({ form, footer }: IRiskParticipantsPicker) {
    const { translateString } = useTranslation();

    return (
        <>
            <DotLegalMultiSelect
                label={translateString("participants")}
                noMargin
                options={form.participantOptions}
                chosenOptions={form.selectedParticipantIds}
                onChange={form.setSelectedParticipantIds}
                noOptionsLabel={translateString("noOptions")}
            />
            {footer}
        </>
    );
}

export default RiskParticipantsPicker;
